import {Length, IsEmail, IsString, Matches, IsNotEmpty} from 'class-validator';

/**
 * Class to define the properties of the form with validation.
 */
class UserForm {
    @IsNotEmpty()
    @IsString()
    firstName: string;

    @IsNotEmpty()
    @IsString()
    lastName: string;

    @IsNotEmpty()
    @IsEmail()
    email: string;

    @IsNotEmpty()
    @IsString()
    @Matches(/\+\d{10,}/i)
    phone: string;

    @IsNotEmpty()
    @IsString()
    streetAndNumber: string;

    @IsNotEmpty()
    @Matches(/^(\d{4})$|^(\d{4} ?[A-Z]{2})$/i)
    postalCode: string;

    @IsNotEmpty()
    @IsString()
    city: string;

    @IsNotEmpty()
    @IsString()
    @Length(2,2)
    country: string;
}

export default UserForm;